<template>
<svg width="47" height="47" viewBox="0 0 47 47" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M32 0H15C6.71573 0 0 6.71573 0 15V32C0 40.2843 6.71573 47 15 47H32C40.2843 47 47 40.2843 47 32V15C47 6.71573 40.2843 0 32 0Z" fill="none"/>
<path class="icon-back" fill-rule="evenodd" clip-rule="evenodd" d="M30.7349 18.5454C30.819 18.4615 30.8857 18.3618 30.9312 18.252C30.9767 18.1423 31.0002 18.0247 31.0003 17.9059C31.0004 17.787 30.977 17.6694 30.9316 17.5596C30.8862 17.4498 30.8197 17.35 30.7357 17.2659C30.6517 17.1819 30.552 17.1152 30.4423 17.0696C30.3325 17.0241 30.2149 17.0006 30.0961 17.0006C29.9773 17.0005 29.8596 17.0238 29.7498 17.0692C29.64 17.1146 29.5403 17.1812 29.4562 17.2652L24 22.7213L18.5454 17.2652C18.3757 17.0954 18.1454 17 17.9053 17C17.6652 17 17.4349 17.0954 17.2652 17.2652C17.0954 17.4349 17 17.6652 17 17.9053C17 18.1454 17.0954 18.3757 17.2652 18.5454L22.7213 24L17.2652 29.4546C17.1811 29.5386 17.1144 29.6384 17.0689 29.7483C17.0234 29.8581 17 29.9758 17 30.0947C17 30.2136 17.0234 30.3313 17.0689 30.4411C17.1144 30.551 17.1811 30.6508 17.2652 30.7348C17.4349 30.9046 17.6652 31 17.9053 31C18.0242 31 18.1419 30.9766 18.2517 30.9311C18.3616 30.8856 18.4614 30.8189 18.5454 30.7348L24 25.2787L29.4562 30.7348C29.626 30.9044 29.8561 30.9996 30.0961 30.9994C30.3361 30.9993 30.5661 30.9038 30.7357 30.7341C30.9053 30.5643 31.0004 30.3341 31.0003 30.0941C31.0001 29.8542 30.9047 29.6241 30.7349 29.4546L25.2787 24L30.7349 18.5454Z" fill="white"/>
</svg>


</template>

<script>
export default {
  name: "IconBack",

  props: {
    width: {
      default: 47,
      required: false,
      type: Number
    },
    height: {
      default: 47,
      required: false,
      type: Number
    }
  }
}
</script>

<style scoped>

</style>